import styled from 'styled-components';
import { isMobile } from 'react-device-detect'

const LayoutContentStyle = styled.div`
  width: 100%;
  padding: ${isMobile ? '16px' : '24px'};
  background-color: ${(props) => props.theme.tokens.surface};
  color: ${(props) => props.theme.tokens.textPrimary};
  border: 1px solid ${(props) => props.theme.tokens.border};
  height: 100%;
`;

export default LayoutContentStyle;
